export const canViewDocuments = (currentUserRole: string): boolean => {
  return ['admin_bank', 'agent_saisie', 'superviseur', 'auditeur', 'conformité'].includes(currentUserRole);
};

export const canViewUsers = (currentUserRole: string): boolean => {
  return ['super_admin', 'admin_bank'].includes(currentUserRole);
};

export const canManageAllStatuses = (currentUserRole: string): boolean => {
  return ['admin_bank', 'superviseur', 'auditeur'].includes(currentUserRole);
};

export const canSeeArchiveStatus = (currentUserRole: string): boolean => {
  return !['agent_saisie'].includes(currentUserRole);
};

export const canSeeRejectedStatus = (currentUserRole: string): boolean => {
  return ['conformité', 'superviseur'].includes(currentUserRole);
};

export const canCreateUsers = (currentUserRole: string): boolean => {
  return ['super_admin', 'admin_bank'].includes(currentUserRole);
};

export const canDeleteSubfoldersAndFiles = (currentUserRole: string): boolean => {
  return ['admin_bank', 'superviseur'].includes(currentUserRole);
};

export const canModifyStatus = (currentUserRole: string): boolean => {
  return !['auditeur'].includes(currentUserRole);
};
